export const FIRST_SCENE_SLUG = "viagem-checkin-aeroporto-beginner";
export const FIRST_SCENE_PATH = `/app?scene=${FIRST_SCENE_SLUG}`;
export const UPGRADE_PATH = "/app/upgrade";

/** Cadastro (ou login) já com o check-in no aeroporto escolhido. */
export function firstSceneAuthPath(tab: "signup" | "signin" = "signup"): string {
  const params = new URLSearchParams({ tab, next: FIRST_SCENE_PATH });
  return `/auth?${params.toString()}`;
}

/** Cadastro ou login e, em seguida, a página de Upgrade / Stripe. */
export function subscribeAuthPath(tab: "signup" | "signin" = "signup"): string {
  const params = new URLSearchParams({ tab, next: UPGRADE_PATH });
  return `/auth?${params.toString()}`;
}

/**
 * Só aceita destinos internos do app. Evita open redirect no ?next=.
 */
export function safeAppPath(raw: string | null | undefined): string | null {
  if (!raw) return null;

  let path = raw.trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    return null;
  }

  if (!path.startsWith("/app")) return null;
  if (path.startsWith("//")) return null;
  if (path.includes("://") || path.includes("\\")) return null;
  return path;
}
